import React from "react";
import { css } from "@emotion/react";
import { useFormContext, useWatch } from "react-hook-form";
import { space } from "main/javascripts/styles/base/spaceStyle";
import {
  fontSize,
  fontWeight,
} from "main/javascripts/styles/base/typographyStyle";
import { SearchFieldButtonSymbol } from "./SearchFieldButtonSymbol";
import { moreThanBreakpoint } from "main/javascripts/styles/base/responsiveStyle";

export interface IProps {
  onClick: any;
}

export const SearchDynamicPackageFieldButton: React.FC<IProps> = (
  props: IProps
): React.ReactElement => {
  const { onClick } = props;

  const { control } = useFormContext();
  const destinationFieldName = "destination";
  const value =
    useWatch({
      control,
      name: destinationFieldName,
    }) || "";

  return (
    <div css={blockStyle}>
      <div css={buttonStyle} onClick={onClick}>
        <div css={destinationStyle}>{value}</div>
        <SearchFieldButtonSymbol />
      </div>
    </div>
  );
};

const blockStyle = css``;
const buttonStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${space.atom} ${space.atom} ${space.atom} ${space.atom1_5x};
  cursor: pointer;
`;
const destinationStyle = css`
  font-size: ${fontSize.body};
  font-weight: ${fontWeight.bold};
  padding-right: ${space.atom};
  overflow-wrap: anywhere;
  ${moreThanBreakpoint("tablet")} {
    font-size: ${fontSize.mediumHeading};
  }
`;
